import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchPerVisitEcrfBlocks = async ({ visitId, patientId, sessionId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!patientId) params.append("patient_id", patientId);
  if (!!sessionId) params.append("session_id", sessionId);

  const URL = `${__API_URL__}/api/ecrf/get_ecrf_blocks_per_visit/${visitId}/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetPerVisitEcrfBlocks = ({ visitId, patientId, sessionId, enabled = true }) => {
  return useQuery({
    queryKey: ["ecrf_blocks_per_visit", visitId, patientId, sessionId],
    queryFn: () => fetchPerVisitEcrfBlocks({ visitId, patientId, sessionId }),
    enabled: enabled && Boolean(visitId && visitId > 0),
  });
};

export default useGetPerVisitEcrfBlocks;
